<script setup lang='ts'>
import { useI18n } from 'vue-i18n';

import useCartWidget from '@/composables/useCartWidget';

import AccordionMobile from './AccordionMobile.vue';
import CartDetails from './v2/CartDetails.vue';

const props = defineProps<{
  apiKey: string;
}>();
const { t } = useI18n();
const { carts, isEmptyCart } = useCartWidget();
</script>

<template>
  <p v-if="isEmptyCart">
    {{ t('cart.empty') }}
  </p>
  <section v-else>
    <template v-for="cart in carts" :key="cart.id">
      <CartDetails v-if="cart.provider === 'youbook'" />
      <AccordionMobile v-else :cart="cart" :start-open="carts.length === 1" :api-key="props.apiKey" />
    </template>
  </section>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--yb-spacing-sm);
  margin-inline: auto;
}
</style>
